const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/;

export default function isEmailValid(email) {
  return !!email.match(EMAIL_REGEX);
}
